// extracted by mini-css-extract-plugin
export default {"terms-content-wrapper":"_termsandpolicies_terms-content-wrapper__ndMH2"};